import React from 'react';
import { CheckboxProps } from 'types/components.types';

const Checkbox: React.FC<CheckboxProps> = ({ 
  label, 
  checked, 
  onChange, 
  id,
  className = '',
  ...props 
}) => {
  const checkboxId = id || `checkbox-${Math.random().toString(36).substr(2, 9)}`;

  return (
    <div className={`flex items-center ${className}`}>
      <input
        type="checkbox"
        id={checkboxId}
        checked={checked}
        onChange={onChange}
        className="h-4 w-4 text-teal-600 focus:ring-teal-500 border-gray-300 rounded"
        {...props}
      />
      {label && (
        <label 
          htmlFor={checkboxId} 
          className="ml-2 text-sm text-gray-700 cursor-pointer"
        >
          {label}
        </label>
      )}
    </div>
  );
};

export default Checkbox;
